<template>
    <div>
        <div>


            <div class="row align-items-center">
                <div class="col col-11">
                    <div class="card-header border-0">
                        <h3 class="card-title align-items-start flex-column">
                            <span class="card-label page-title fw-bolder fs-3 mb-1"
                            >Emails</span
                            >
                        </h3>
                    </div>
                </div>
                <div class="col">
                    <button
                        type="button"
                        @click="initialGetEmails()"
                    >
                        <i class="fas fa-redo fa-2x"></i>

                    </button>
                </div>
            </div>

            <input
            type="text"
            class="form-control form-control-lg form-control-solid px-15"
            v-model="search"
            placeholder="Search"
            data-kt-search-element="input"
            />
        <!--end::Input-->
      </div>

      <div class="spacer-y-10"></div>

        <!--begin::Table container-->
      <v-data-table
        :headers="tableHeaders"
        :items="searchResults"
        item-key="id"
        class="elevation-1"
        :loading="loadingList"
        loading-text="Loading Emails..."
        :page.sync="currentPage"
        @page-count="pageCount = $event"
        :sort-by="sort.by"
        :sort-desc="sort.desc"
      >

        <template v-slot:[`item.actions`]="{ item }">
            <router-link
              :to="{
                name: 'ViewEmail',
                params: { emailId: item.id },
              }"
              >View</router-link
            >
        </template>

      </v-data-table>
      <!--end::Table-->
    </div>
</template>

<script>
import { ApiService } from '@/services/ApiService';
import { error } from '@/services/LoggerService';

    export default {
        name: "ManageNotificationEmails",
        data() {
            return {
                loadingList: false,
                search: "",
                limit: 1000,
                pullLimit: 1000,
                startKey: null,
                emails: [],
                pageCount: 0,
                currentPage: 1,
                sort: {
                    by: ["name"],
                    desc: [false]
                },
                tableHeaders: [
                    { text: 'Email', value: 'name'},
                    { text: "Actions", value: "actions" }
                ],
            }
        },
        computed: {
            searchResults() {
                if(!this.search) return this.emails;

                return this.emails.filter((e) => {
                    return (
                        e.name.toLowerCase().includes(this.search.toLowerCase())
                    );
                });
            },
            isLastPage(){
                if(this.pageCount < 1){
                    return false;
                }

                return this.currentPage >= this.pageCount;
            }
        },
        watch: {
            isLastPage(newValue) {
                if(!newValue){
                    return;
                }
                this.loadMoreData();
            }
        },
        methods: {
            async loadMoreData(){
                if(!this.startKey){
                    return;
                }

                await this.getEmails(this.startKey);
            },
            async initialGetEmails(){
                this.emails = [];
                this.startKey = null;
                await this.getEmails();
            },
            async getEmails(startKey) {
                try{
                    do{
                        this.loadingList = true;
                        const result = await ApiService.Instance.getEmails({
                            headers: {
                                startKey,
                                limit: this.limit
                            }
                        });

                        if(!!result.data){
                            this.emails.push(...result.data);
                        }

                        startKey = result.lastEvaluatedKey;
                        this.startKey = result.lastEvaluatedKey;
                    }while(this.emails < this.pullLimit && !!this.startKey);
                }catch(e){
                    error(e);
                }
                this.loadingList = false;
            }
        },
        async beforeMount () {
            await this.initialGetEmails();
        },
    }
</script>

<style lang="scss" scoped>

</style>